import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import { tabVisible } from '@platform/plugin-platform-react';

/**
 * L'onglet « Secrets » des charges de travail déployées.
 *
 * Contrairement à « Sécurité » et « Observabilité », cet onglet n'était
 * enveloppé dans AUCUNE garde de permission dans `entityRoutes.tsx` : il
 * s'affichait pour tout utilisateur, et c'est son contenu qui gère les droits
 * d'édition. Ce comportement est repris tel quel — ajouter une garde ici
 * serait un changement fonctionnel, pas une extraction.
 */
const isComponent = (entity: Entity): boolean =>
  entity.kind?.toLowerCase() === 'component';

const secretsContent = EntityContentBlueprint.make({
  name: 'secrets',
  params: {
    path: '/secrets',
    title: "Variables d'env",
    filter: tabVisible('env', isComponent),
    loader: () =>
      import('./EnvManagerContent').then(m => <m.EnvManagerContent />),
  },
});

export default createFrontendPlugin({
  pluginId: 'env-manager',
  extensions: [secretsContent],
});
